/**
 * Auth Configuration Utility
 * Determines auth settings based on environment
 */

export interface AuthConfig {
  apiUrl: string;
  supportsGoogleOAuth: boolean;
  useHttpOnlyCookies: boolean;
  environment: 'cloud' | 'selfhosted' | 'development';
}

export function getAuthConfig(): AuthConfig {
  const hostname = window.location.hostname;
  
  // Self-hosted detection
  if (hostname === 'app.riversystem.ai' || hostname === 'riversystem.ai' || hostname.endsWith('.riversystem.ai') ||
      process.env.REACT_APP_AUTH_MODE === 'selfhosted') {
    return {
      apiUrl: process.env.REACT_APP_API_URL || 'https://app.riversystem.ai/api',
      supportsGoogleOAuth: false, // No Google OAuth for self-hosted
      useHttpOnlyCookies: true,   // Secure httpOnly cookies
      environment: 'selfhosted'
    };
  }
  
  // Development
  if (process.env.NODE_ENV === 'development') {
    return {
      apiUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api',
      supportsGoogleOAuth: true,  // Keep Google OAuth for dev
      useHttpOnlyCookies: false,  // localStorage for dev
      environment: 'development'
    };
  }
  
  // Cloud (default)
  return {
    apiUrl: process.env.REACT_APP_API_BASE_URL || 'https://api.bedrock.computer/api',
    supportsGoogleOAuth: true,   // Google OAuth available
    useHttpOnlyCookies: false,   // localStorage tokens
    environment: 'cloud'
  };
}
